import { Rating, SvgIcon, Typography } from '@ascd/witsby-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Divider, IconButton } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import { IDashboardData } from '@types';

interface IAdminDashboardTopLearningStatics {
  countText?: string;
  data?: IDashboardData[];
  onMoreClick?: () => void;
}

const AdminDashboardTopLearningStatics = ({
  data,
  countText,
  onMoreClick,
}: IAdminDashboardTopLearningStatics) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}>
    <Box sx={{ mt: 2, height: '100%' }}>
      {isEmpty(data) ? (
        <Box
          sx={{
            height: '90%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          No data found
        </Box>
      ) : (
        data?.slice(0, 5)?.map((topLearning) => (
          <Box key={topLearning._id}>
            <Box
              sx={(theme) => ({
                color: theme.palette.grey[200],
                fontSize: theme.font.size.SMALL,
              })}>
              {topLearning.title || 'Untitled'}
            </Box>
            {countText ? (
              <Box
                sx={(theme) => ({
                  color: theme.palette.grey[200],
                  fontSize: theme.font.size.X_SMALL,
                  fontWeight: theme.font.weight.LIGHT,
                })}>
                {topLearning.count} {countText}
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <Rating readOnly size="small" precision={0.5} value={topLearning?.averageRating} />
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SvgIcon
                    icon="USERS"
                    viewBox="0 0 20 15"
                    sx={{
                      fontSize: (theme) => theme.font.size.REGULAR,
                      path: { fill: (theme) => theme.palette.grey[300] },
                    }}
                  />
                  <Typography
                    sx={(theme) => ({
                      color: theme.palette.grey[300],
                      fontSize: theme.font.size.SMALL,
                    })}
                    text={topLearning?.numberOfRatings || '0'}
                  />
                </Box>
              </Box>
            )}
            <Divider sx={{ pt: 1, mb: 1 }} />
          </Box>
        ))
      )}
    </Box>
    {!isEmpty(data) && (
      <Box sx={{ textAlign: 'center' }}>
        <IconButton
          aria-label="More"
          onClick={onMoreClick}
          sx={(theme) => ({
            color: theme.palette.grey[200],
            fontSize: theme.font.size.X_SMALL,
            svg: {
              fontSize: theme.font.size.REGULAR,
            },
          })}>
          more <ExpandMoreIcon />
        </IconButton>
      </Box>
    )}
  </Box>
);

export default AdminDashboardTopLearningStatics;
